<template>
  <signup :title="'הרשמה לשירות'"
  :sub-title="'ליצירת החשבון נצטרך כמה פרטים:'"
  :button-title="'הרשמה'"
  :button-action="generateCodeAndProceed"
          :error="serverErrors.generateCode"
          :reset-error="() => resetError('generateCode')">
    <template v-slot:header>
      <riseup-header/>
      <snack-bar class="expired-promotion" v-if="!isPromotionEligible" :text="'תוקף ההטבה הסתיים'" :variant="'warning'"/>
    </template>
    <template v-slot:information-details>
      <information-details :title="'חודש ראשון ב-riseup חינם'"
                           :details="['משלמים רק מהחודש השני לשימוש, ₪45 לחודש',
                          'בלי התחייבות, אפשר לבטל בכל שלב',
                           'לא צריך להכניס פרטי אשראי עד לתום תקופת הניסיון']"/>
    </template>
  </signup>
</template>

<script>

import Signup from '@/base-components/Signup';
import InformationDetails
  from '@/pages/responsive-pages/non-authenticated/wine-and-dine/signup/steps/InformationDetails';
import BaseUI from 'base-ui';
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import Segment from '../../../../../../Segment';
import RiseupHeader from '../../../../../../base-components/app-header/RiseupHeader.vue';

export default {
  name: 'Introduction',
  components: {
    RiseupHeader,
    Signup,
    InformationDetails,
    SnackBar: BaseUI.SnackBar,
  },
  props: {
    next: {
      type: Function,
      required: true,
    },
  },
  async created() {
    Segment.trackUserGot('RegistrationEntered');
    Segment.trackUserGotToPixel('RE');
  },
  computed: {
    ...mapState('signup', ['phoneNumber', 'firstName', 'lastName', 'serverErrors', 'email', 'enableMarketingEmails']),
    ...mapGetters('promotions', ['isPromotionEligible']),
  },
  methods: {
    ...mapActions('signup', ['generateCode']),
    ...mapMutations('signup', ['setFirstName', 'setLastName', 'setPhoneNumber', 'resetError', 'setEmail', 'setEnableMarketingEmails']),
    async generateCodeAndProceed(firstName, lastName, phoneNumber, email, enableMarketingEmails) {
      await this.setFirstName(firstName);
      await this.setLastName(lastName);
      await this.setPhoneNumber(phoneNumber);
      await this.setEmail(email);
      await this.setEnableMarketingEmails(enableMarketingEmails);
      Segment.trackUserInteraction('GenerateCodeClicked', {
        firstName: this.firstName,
        lastName: this.lastName,
        phoneNumber: this.phoneNumber,
        isMarketingConsent: this.enableMarketingEmails,
      });
      await this.generateCode();
      this.next();
    },
    goToLogin() {
      window.location.href = '/sr';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';
@import '../../../../../../scss/mixins';
.expired-promotion {
  @include responsive-padding;
  width: 100%;
}
</style>
